import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import useGetSites from "../../../hooks/api/useGetSites";
import {Site} from "../../../types/Site";

// Types ----

type SitesPanelProps = {
  onSelect: (site: Site) => void
  selectedItems: SelectedItemsData
  isMaxSelected?: boolean
}

// Component ----

function SitesPanel({ onSelect, selectedItems, isMaxSelected }: SitesPanelProps) {
  const {data: sites, isLoading} = useGetSites({
    per_page: 1000,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!sites?.data?.length ? sites?.data.map(site => {
                const selected = isSelected(site, ENTITY_TYPES.SITE, selectedItems);

                return (
                  <Card
                    key={site.id}
                    onClick={() => onSelect(site)}
                    heading={site.name}
                    footer={site.address.city}
                    imageUrl={site.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {SitesPanel};